import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import PhysicalActivitySlider from './../../components/PhysicalActivitySlider/PhysicalActivitySlider';
import * as actionTypes from './../../store/actions/physicalActivityAction';
import fetchPhysicalActivityAction from './../../store/actions/fetch/fetchPhysicalActivityAction';
import Loader from './../../components/Loader/Loader';
import * as helpActionTypes from './../../store/actions/helpAction';


/**
 * Weight Adjustment container
 */
class PhysicalActivity extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, selectedDuration, selectedIntensity,
      selectedTemperature, onSelectDuration, onSelectIntensity,
      onSelectTemperature, selectedAnimalType, defaultValues, selectedType,
      readyAnimalType, ready, readyCriticalCare,
      selectedCriticalCare, openModalWithContent} = this.props;
    // If there is a need for default data
    if(!error  && !pending && readyAnimalType && readyCriticalCare && (!ready ||
      selectedType !== selectedAnimalType)) {
      defaultValues(selectedAnimalType);
    }
    // Also default if critical care
    if(selectedCriticalCare){
      defaultValues(selectedAnimalType);
    }
    // If data is pending
    if(pending || !readyAnimalType || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-physical-activity-slider__wrapper'>
        {error && <span className='nppe2-fc-physical-activity-slider__error'>{error}</span>}
        {!error &&
        <PhysicalActivitySlider data={data}
                                selectedDuration={selectedDuration}
                                selectedIntensity={selectedIntensity}
                                selectedTemperature={selectedTemperature}
                                onSelectDuration={onSelectDuration}
                                onSelectIntensity={onSelectIntensity}
                                onSelectTemperature={onSelectTemperature}
                                animalType={selectedAnimalType}
                                selectedCriticalCare={selectedCriticalCare}
                                openModalWithContent={openModalWithContent}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedDuration: state.physicalActivityReducer.selectedDuration,
    selectedIntensity: state.physicalActivityReducer.selectedIntensity,
    selectedTemperature: state.physicalActivityReducer.selectedTemperature,
    selectedType: state.physicalActivityReducer.selectedType,
    error: state.physicalActivityReducer.error,
    data: state.physicalActivityReducer.data,
    pending: state.physicalActivityReducer.pending,
    readyAnimalType: state.animalTypeReducer.ready,
    selectedAnimalType: state.animalTypeReducer.animalType,
    ready: state.physicalActivityReducer.ready,
    selectedCriticalCare: state.criticalCareReducer.selected,
    readyCriticalCare: state.criticalCareReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchPhysicalActivityAction
      },
      dispatch,
    ),
    onSelectDuration: (id) => dispatch({
      type: actionTypes.SELECT_DURATION,
      selectedDuration: id,
    }),
    onSelectIntensity: (id) => dispatch({
      type: actionTypes.SELECT_INTENSITY,
      selectedIntensity: id,
    }),
    onSelectTemperature: (id) => dispatch({
      type: actionTypes.SELECT_TEMPERATURE,
      selectedTemperature: id,
    }),
    defaultValues: (selectedAnimalType) => dispatch({
      type: actionTypes.DEFAULT,
      selectedAnimalType: selectedAnimalType,
    }),
    openModalWithContent: (key) => dispatch({
      type: helpActionTypes.OPEN_MODAL_WITH_CONTENT,
      key: key,
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PhysicalActivity);
